import { Col, Row } from 'reactstrap';
import { getTranslationKey } from '../modules/utils';
import Card, { CardBody, CardHeader, CardTitle } from '../components/Card';

const PageLayout = ({ children }: { children: any }) => (
  <div className="animated fadeIn">
    <Row>
      <Col sm="12" md="12" lg="6">
        {children}
      </Col>
    </Row>
  </div>
);

export const TaxSettings = () => (
  <PageLayout>
    <Card>
      <CardHeader>
        <CardTitle>{getTranslationKey('settingsSection.taxSettingMenuLabel')}</CardTitle>
      </CardHeader>
      <CardBody>
        <p>{getTranslationKey('settingsSection.taxSettingMovedNotice')}</p>
        <a href="/#/shop/payment-settings?tab=tax-settings">
          {getTranslationKey('settingsSection.taxSettingMovedLink')}
        </a>
      </CardBody>
    </Card>
  </PageLayout>
);

export default TaxSettings;
